module.exports = __webpack_public_path__ + "img/no.6f891d92.svg";